var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Badge, IconButton, styled, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
const PopperWapper = styled("div")(({ theme }) => {
    return {
        ".header_right-section_icon": {
            borderRadius: 90,
            padding: 12,
        },
        [theme.breakpoints.down(475)]: {
            ".header-right_icons": {
                ".header_right-section_icon": {
                    minWidth: "50px !important",
                },
            },
        },
        [theme.breakpoints.down(375)]: {
            ".header-right_icons": {
                display: "flex",
                width: 100,
                overflow: "auto",
                ".header_right-section_icon": {
                    minWidth: "50px !important",
                },
            },
            ".MuiPaper-root": {
                background: "red",
            },
        },
    };
});
export const PopperComponent = (props) => {
    const rest = __rest(props, []);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [iconIndex, setIconIndex] = React.useState(null);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.only("xs"));
    const handleClick = (index) => (event) => {
        var _a;
        if (iconIndex === index) {
            setIconIndex(null);
            return setOpen(false);
        }
        setAnchorEl(event.currentTarget);
        setOpen(false);
        if (iconIndex !== null && !((_a = props.list[iconIndex]) === null || _a === void 0 ? void 0 : _a.Component)) {
            setIconIndex(index);
            return props.callback(props.list[iconIndex]);
        }
        setOpen(true);
        setIconIndex(index);
    };
    const { Component } = (iconIndex !== null && props.list[iconIndex]) || {};
    return (React.createElement(PopperWapper, Object.assign({}, rest),
        React.createElement(Box, { className: "header-right_icons" },
            React.createElement(Popper, { open: open, sx: {
                    zIndex: 4,
                    maxWidth: "80vw",
                    maxHeight: "100vh",
                }, anchorEl: anchorEl, placement: "bottom-end", transition: true }, ({ TransitionProps }) => (React.createElement(Fade, Object.assign({}, TransitionProps, { timeout: 350 }),
                React.createElement(Paper, { sx: isSmallScreen ? { width: "100%", overflow: "scroll" } : {}, className: "paper_wrapper" }, Component && React.createElement(Component, null))))),
            React.createElement(React.Fragment, null, props.list.map((iconInfo, index) => {
                return (React.createElement(IconButton, { className: "header_right-section_icon", onClick: handleClick(index), key: `btn${iconInfo === null || iconInfo === void 0 ? void 0 : iconInfo.alt}` },
                    React.createElement(Badge, { badgeContent: iconInfo === null || iconInfo === void 0 ? void 0 : iconInfo.badge, color: "primary" },
                        React.createElement(React.Fragment, null,
                            React.createElement("img", { alt: iconInfo === null || iconInfo === void 0 ? void 0 : iconInfo.alt, src: iconInfo === null || iconInfo === void 0 ? void 0 : iconInfo.image, className: "header_right-icon" })))));
            })))));
};
